import { render } from "./PreMint.vue?vue&type=template&id=1b866eb1"
import script from "./PreMint.vue?vue&type=script&lang=js"
export * from "./PreMint.vue?vue&type=script&lang=js"

import "./PreMint.vue?vue&type=style&index=0&id=1b866eb1&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__